export default "__VITE_ASSET__BLWpeAKz__"